import DigitalReach from "../Components/DigitalReach";

const DigitalReachPage = () => {
  return <DigitalReach />;
};

export default DigitalReachPage;
